declare namespace $ {

	export class $shm_tests_benchmark_table extends $mol_grid {
		table_records( ): Record<string, any>
		table_columns( ): readonly(any)[]
		column_title( id: any): readonly(any)[]
		results( ): readonly(any)[]
		step_title( ): string
		step_index( ): number
		has_benchmarks( ): boolean
		records( ): ReturnType< $shm_tests_benchmark_table['table_records'] >
		col_ids( ): ReturnType< $shm_tests_benchmark_table['table_columns'] >
		col_head_content( id: any): ReturnType< $shm_tests_benchmark_table['column_title'] >
		row_height( ): number
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map